import { FAMYLOCATE_COHORTS } from 'root-constants/common'

export const isFamylocateCohort = (cohort: string) => {
  return FAMYLOCATE_COHORTS.includes(cohort)
}
